import React, { useState } from "react";
import { Col, Dropdown, Row, Table, Tag, Typography } from "antd";
import type { MenuProps, TableProps } from "antd";
import { MenuOutlined } from "@ant-design/icons";

import "./../../styles/tables.css";

import { useNavigate } from "react-router-dom";
import { formatDateForJustMonthDayAndYear } from "../../helpers/date";
import TailSpinLoader from "../Items/Loaders/TailSpinLoader";

// const TailSpinLoader = lazy(() => import("../Items/Loaders/TailSpinLoader"));

const ViewStaffTable: React.FC<StaffTableProp> = ({
  staff,
  isLoading,
  handleStaffProfileUpdate,
  handleStaffPasswordUpdate,
}) => {
  const [activeRow, setActiveRow] = useState<StaffListType | null>(null);

  const staffOptions: MenuProps["items"] = [
    {
      key: "VIEW_PROFILE",
      label: (
        <Typography className="general-label-class">View Details</Typography>
      ),
    },
    {
      key: "UPDATE_PROFILE",
      label: (
        <Typography className="general-label-class">Update Profile</Typography>
      ),
    },
    {
      key: "UPDATE_PASSWORD",
      label: (
        <Typography className="general-label-class">Update Password</Typography>
      ),
    },
  ];

  const handleMenuClick = (e: any) => {
    if (!activeRow) {
      return;
    }
    switch (e.key) {
      case "VIEW_PROFILE":
        return navigate(`/staff-profile/${activeRow.intPkHeadID}`);
        break;
      case "UPDATE_PROFILE":
        handleStaffProfileUpdate(activeRow);
        break;
      case "UPDATE_PASSWORD":
        handleStaffPasswordUpdate(activeRow);
        break;
    }
  };

  const navigate = useNavigate();
  const columns: TableProps<StaffListType>["columns"] = [
    {
      title: "Name",
      render: (row) => <span>{`${row.firstName} ${row.lastName}`}</span>,
    },
    {
      title: "UserName",
      dataIndex: "staffUserName",
      key: "staffUserName",
    },
    // {
    //   title: "Email",
    //   dataIndex: "email",
    //   key: "email",
    // },
    {
      title: "Phone",
      dataIndex: "phoneNumber",
      key: "phoneNumber",
    },

    {
      title: "Wallet Limit",
      render: (row) => <span>{`${row.walletLimit.toLocaleString()} PKR`}</span>,
    },
    {
      title: "Wallet Days",
      render: (row) => <span>{`${row.walletDays} Days`}</span>,
    },
    {
      title: "Available Balance",
      render: (row) => (
        <span className="balance-available-label">{`${
          row?.userBalance?.cashAvailable?.toLocaleString() || 0
        } PKR`}</span>
      ),
    },
    {
      title: "Created",
      dataIndex: "dateCreated",
      render: (text) => (
        <span>{formatDateForJustMonthDayAndYear(new Date(text))}</span>
      ),
    },

    {
      title: "Last Deposit",
      // dataIndex: "dateCreated",
      render: (row) => (
        <span>
          {row.lastDepositDate
            ? formatDateForJustMonthDayAndYear(new Date(row.lastDepositDate))
            : "-"}
        </span>
      ),
    },

    {
      title: "Action",
      render: (row) => (
        <Dropdown
          menu={{
            items: staffOptions,
            onClick: handleMenuClick,
          }}
          placement="bottomRight"
        >
          <MenuOutlined
            onMouseEnter={(e) => {
              setActiveRow(row);
            }}
            className="cursor-pointer"
          />
        </Dropdown>
      ),
    },
  ];

  return (
    <div className="general-table-container">
      {isLoading === true ? (
        <TailSpinLoader />
      ) : (
        <Row>
          <Col span={24}>
            <Typography className="general-table-heading">
              Staff List
            </Typography>
            <Table
              className=" striped-table"
              columns={columns}
              dataSource={staff}
              onRow={(record, rowIndex) => {
                return {};
              }}
              pagination={false}
            />
          </Col>
          <Col
            style={{
              display: "flex",
              justifyContent: "flex-end",
              marginTop: "20px",
              marginBottom: "20px",
            }}
            span={24}
          ></Col>
        </Row>
      )}
    </div>
  );
};
export default ViewStaffTable;
